import { ICandidate, ViewCVData, newJobBoardCandidateEntity } from 'wisestep-api';

import { IBreadCrumbsList } from '../../../components/WsBreadCrumbs';
import BasicSearchForm from '../types/IBasicSearchForm';

export const toLowerCaseWithFirstLetterCapital = (value: string) =>
  value.charAt(0) + value.slice(1).toLowerCase().replaceAll('_', ' ');

export const getJobBoardUrl = (jobBoardName: string) => {
  switch (jobBoardName) {
    case 'DICE_SEARCH':
      return '/native-search-settings';
    case 'CAREER_BUILDER':
      return '/native-search-settings/cb-rdb';
    case 'TECH_FETCH':
      return '/native-search-settings/techFetch';
    case 'CV_LIBRARY':
      return '/native-search-settings/cv-library';
    case 'MONSTER':
      return '/native-search-settings/monster';
    case 'JOBSERVE':
      return '/native-search-settings/job-serve';
    case 'CW_JOBS':
      return '/native-search-settings/cw-job';
    case 'JOB_SITE':
      return '/native-search-settings/job-site';
    case 'CAREER_BUILDER_EDGE':
      return '/native-search-settings/cb-edge';
    default:
      return '/native-search-settings';
  }
};

export default {
  query: '',
  sort: 'relevancy',
  accountId: '',
  lastActive: '90',
  distance: 50,
  page: 1,
  pageSize: 50,
  countrySelect: '',
  sortDirection: 'desc',
  locations: [],
  zipcode: '',
} as BasicSearchForm;

export const getViewCVCandidateData = (candidateData: ICandidate) => {
  const viewCVData: ViewCVData = newJobBoardCandidateEntity();
  viewCVData.name = candidateData.name;
  viewCVData.currentJobTitle = candidateData.currentJobTitle;
  viewCVData.totalYearsExperience = candidateData.totalYearsExperience;
  viewCVData.workAuthorization = candidateData.workAuthorization;
  viewCVData.dateResumeLastUpdatedOnJobBoard = candidateData.dateResumeLastUpdatedOnJobBoard;
  viewCVData.currentLocation = candidateData.currentLocation;
  viewCVData.currentSalary = candidateData.currentSalary;
  viewCVData.currentSalaryCurrency = candidateData.currentSalaryCurrency;
  viewCVData.currentSalaryTimeSpan = candidateData.currentSalaryTimeSpan;
  viewCVData.willingToRelocate = candidateData.willingToRelocate;
  viewCVData.likelyToMove = candidateData.likelyToMove;
  viewCVData.skills = candidateData.skills;
  viewCVData.workPreferences = candidateData.workPreferences;
  viewCVData.candidateId = candidateData.candidateId;
  return viewCVData;
};

export const getCandidateId = (candidateData: ICandidate) =>
  candidateData?.id === candidateData?.candidateId ? candidateData?.candidateId : candidateData?.id;

export const generateJobBoardURL = (): IBreadCrumbsList[] => [
  { label: 'Job Boards', url: `${window.location.pathname}${window.location.search}` },
];
